import { RxEnrichmentAPI, EnrichmentAPI, checkStatus, json } from '@driftt/dapper'
import { fromJS } from 'immutable'

export const api = {
  fetchEnrichedCompanyData(options = {}) {
    return RxEnrichmentAPI.get(`/company`, options)
      .checkStatus()
      .mapResponse(fromJS)
  },

  fetchDriftIntelTrialEligibility(options = {}) {
    return EnrichmentAPI
      .get(`/company/trial/eligible`, options)
      .then(checkStatus)
      .then(json)
  },

  fetchDecodedCondition(provider, conditions = [], ip = '127.0.0.1', orgId) {
    return RxEnrichmentAPI.post(`/conditions/targeting/${provider}/audit?ip=${ip}&orgId=${orgId}`, conditions)
      .checkStatus()
  },
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/enrichment/api.js